import { useApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';

export type ContainerSAS = {
  sas: string;
  urls: string[];
};

export const useContainerAccount = ({
  namespace,
  name,
}: {
  namespace: string;
  name: string;
}) => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef) ?? { fetch };

  const generateSASToken = async (
    containerName: string,
    duration?: number,
  ): Promise<ContainerSAS> => {
    const baseUrlData = await discoveryApi.getBaseUrl('storage-account');

    const urlData = `${baseUrlData}/${namespace}/${name}/container-sas/${containerName}?duration=${duration}`;

    const responseData = await fetchApi.fetch(urlData);
    if (!responseData.ok) {
      throw await ResponseError.fromResponse(responseData);
    }

    return await responseData.json();
  };

  return { generateSASToken };
};
